import { COUNTRIES_ISO_3 } from '../../constants';
const isOBSAddress = (address) => Object.keys(address).some((key) => key === 'default_address');
const isCustomerCountry = (address, country) => {
    var _a, _b;
    const customerCountry = isOBSAddress(address)
        ? (_a = address.default_address) === null || _a === void 0 ? void 0 : _a.country
        : (_b = address === null || address === void 0 ? void 0 : address.address) === null || _b === void 0 ? void 0 : _b.countryCode;
    return customerCountry === country;
};
export function isDEUCustomer(address) {
    return isCustomerCountry(address, COUNTRIES_ISO_3.DEU);
}
export function isAUTCustomer(address) {
    return isCustomerCountry(address, COUNTRIES_ISO_3.AUT);
}
export function isGBRCustomer(address) {
    return isCustomerCountry(address, COUNTRIES_ISO_3.GBR);
}
export function isIRLCustomer(address) {
    return isCustomerCountry(address, COUNTRIES_ISO_3.IRL);
}
export function isNLDCustomer(address) {
    return isCustomerCountry(address, COUNTRIES_ISO_3.NLD);
}
export function isESPCustomer(address) {
    return isCustomerCountry(address, COUNTRIES_ISO_3.ESP);
}
export function isFRACustomer(address) {
    return isCustomerCountry(address, COUNTRIES_ISO_3.FRA);
}
export function isPOLCustomer(address) {
    return isCustomerCountry(address, COUNTRIES_ISO_3.POL);
}
export function isFINCustomer(address) {
    return isCustomerCountry(address, COUNTRIES_ISO_3.FIN);
}
//# sourceMappingURL=customerAddress.js.map